import React from "react";

import card from "assets/img/card-shadow.png";
import profile from "assets/img/profile.svg";
import calculator from "assets/img/calculator.svg";
import wallet from "assets/img/wallet.svg";
import lock from "assets/img/lock.svg";
import check from "assets/img/Rectangleblue.svg";

import "assets/styles/ecommerce/RegisterEcommerce.scss";

import TitleLeft from "components/common/sections/TitleLeft";
import Clearfix from "components/common/Clearfix";
import Card from "components/ecommerce/sections/RegisterEcommerceCard";

const RegisterEcommerce = () => {
  return (
    <div className={'registerWrapper'}>
      <div className={'register'}>
        <div className={'header'}>
          <TitleLeft>Proceso de onboarding ágil y seguro para pagos en línea</TitleLeft>
        </div>
      </div>
    </div>
  );
};

export default RegisterEcommerce;
